/**
 * @param {{ src?: string | null, name?: string, size?: 'sm' | 'md' | 'lg', className?: string }} props
 */
import { SecureImage } from './SecureImage.jsx';

export function Avatar({ src, name = '', size = 'md', className = '' }) {
  const sizes = { sm: 'h-8 w-8', md: 'h-10 w-10', lg: 'h-16 w-16' };
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  const ringClass = 'ring-2 ring-white shadow-sm';

  if (src) {
    return (
      <SecureImage
        src={src}
        alt={name || 'Avatar'}
        className={`rounded-full object-cover ${sizes[size]} ${ringClass} ${className}`}
        loading="lazy"
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-brand/15 font-medium text-brand ${sizes[size]} ${ringClass} ${className}`}
    >
      {initials || '?'}
    </div>
  );
}
